import mixpanel from 'mixpanel-browser';

import { BuildADashTrackingEvents } from '@revelio/core';

type AIAssistantSurface = 'global' | 'dashboard' | 'report';

type AIAssistantPromptMode = 'generate' | 'update' | 'clarification_answer';

type TrackAIAssistantPromptArgs = {
  assistantSurface: AIAssistantSurface;
  conversationId: string;
  turnIndex: number;
  /** Joins the prompt to the outcomes of the turn it starts (global only). */
  turnId?: string;
  promptText: string;
  promptMode: AIAssistantPromptMode;
  entityType?: string;
  /** Pathname the prompt was submitted from. Defaults to the current location. */
  pagePath?: string;
};

export function trackAIAssistantPrompt({
  assistantSurface,
  conversationId,
  turnIndex,
  turnId,
  promptText,
  promptMode,
  entityType,
  pagePath,
}: TrackAIAssistantPromptArgs): void {
  const resolvedPagePath =
    pagePath ??
    (typeof window !== 'undefined' ? window.location.pathname : undefined);
  mixpanel.track(BuildADashTrackingEvents.AI_ASSISTANT_PROMPT_SUBMIT, {
    assistant_surface: assistantSurface,
    conversation_id: conversationId,
    turn_index: turnIndex,
    ...(turnId ? { turn_id: turnId } : {}),
    is_first_message: turnIndex === 1,
    prompt_text: promptText,
    prompt_length: promptText.length,
    prompt_mode: promptMode,
    ...(entityType ? { entity_type: entityType } : {}),
    ...(resolvedPagePath ? { page_path: resolvedPagePath } : {}),
  });
}
